import { useEffect } from 'react';
import { Link, Navigate, useNavigate } from 'react-router';

import { Card, PageContainer } from '@shared';

import { LoginForm } from '@/features/auth/LoginForm';
import { useAuth } from '@/features/auth/useAuth';
import { useTranslations } from '@/i18n/client';

export function LoginPage() {
  const t = useTranslations('auth.login');
  const navigate = useNavigate();
  const { status, clearError } = useAuth();

  // A stale error from a previous attempt must not greet the user on arrival.
  useEffect(() => clearError(), [clearError]);

  if (status === 'authenticated') {
    return <Navigate to="/" replace />;
  }

  return (
    <PageContainer className="md-login-page flex min-h-full max-w-[46rem] items-start justify-center px-6 py-12 max-sm:w-full max-sm:px-0 max-sm:py-4">
      <Card className="max-sm:box-border max-sm:w-full max-sm:p-4 max-sm:[&_p]:wrap-anywhere">
        <p className="m-0 mb-4 text-lg font-bold tracking-[0.05em] text-[var(--zs-muted)]">{t('eyebrow')}</p>
        <h1 className="mb-3 text-2xl">{t('title')}</h1>
        <p className="m-0 mb-8 text-[var(--zs-muted)]">{t('subtitle')}</p>
        <LoginForm onSuccess={() => void navigate('/', { replace: true })} />
        <p className="m-0 mt-5 text-center text-sm">
          <Link className="font-bold !text-[var(--md-highlight)]" to="/forgot-password">
            {t('forgotPasswordLink')}
          </Link>
        </p>
        <p className="m-0 mt-5 text-center text-sm">
          <span className="text-[var(--md-primary)]">{t('createAccountPrompt')}</span>{' '}
          <Link className="font-bold !text-[var(--md-highlight)]" to="/register">
            {t('createAccountAction')}
          </Link>
        </p>
      </Card>
    </PageContainer>
  );
}
